import { Box, Input, Stack, Text } from '@chakra-ui/react';
import { Col, Row } from 'antd';
import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import {
  validateFormEmailField,
  validateFormNameFiled,
  validatePhoneNumberField,
} from '@/constants/validation.constants';

import { SellYourFormValues } from '../../service';
import Styles from '../SellYourCarForm.module.scss';

export const UserDetailsForm = ({
  control,
  errors,
}: {
  control: Control<SellYourFormValues>;
  errors: FieldErrors<SellYourFormValues>;
}) => (
  <Stack spacing={6}>
    <Row gutter={6}>
      <Col sm={8} style={{ width: '100%' }}>
        <Controller
          name="user_name"
          control={control}
          rules={{
            validate: validateFormNameFiled,
          }}
          render={({ field }) => (
            <Box className={Styles.floatingForm}>
              <Input
                {...field}
                placeholder="Name and surname"
                type="text"
                className={Styles.formInput}
              />
            </Box>
          )}
        />
        {errors.user_name && (
          <Text color="red.500" fontSize="sm">
            {errors.user_name.message}
          </Text>
        )}
      </Col>
      <Col sm={8} style={{ width: '100%' }}>
        <Controller
          name="email"
          control={control}
          rules={{
            required: 'Please input your Email!',
            validate: validateFormEmailField,
          }}
          render={({ field }) => (
            <Box className={Styles.floatingForm}>
              <Input
                {...field}
                type="email"
                className={Styles.formInput}
                placeholder="Email address"
              />
            </Box>
          )}
        />
        {errors.email && (
          <Text color="red.500" fontSize="sm">
            {errors.email.message}
          </Text>
        )}
      </Col>
      <Col sm={8} style={{ width: '100%' }}>
        <Controller
          name="phone_number"
          control={control}
          rules={{
            required: 'Please input your Phone number!',
            validate: validatePhoneNumberField,
          }}
          render={({ field }) => (
            <Box className={Styles.floatingForm}>
              <Input
                {...field}
                type="tel"
                className={Styles.formInput}
                placeholder="Contact number"
              />
            </Box>
          )}
        />
        {errors.phone_number && (
          <Text color="red.500" fontSize="sm">
            {errors.phone_number.message}
          </Text>
        )}
      </Col>
    </Row>
  </Stack>
);
